var _line, _line2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoriesSale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 89,
    viewBox: "0 0 110 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2.18557e-8,
    x2: 0.499999,
    y2: 30,
    stroke: "#333333",
    strokeDasharray: "1 6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 109.5,
    y1: 59,
    x2: 109.5,
    y2: 89,
    stroke: "#333333",
    strokeDasharray: "1 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 38C87.3889 38 95 30.3888 95 21C95 11.6112 87.3889 4 78 4C69.4605 4 62.3916 10.2964 61.1826 18.5C60.6667 22 61.5704 26.7083 62.8725 28.7639C65.6929 34.2484 71.4084 38 78 38Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9074 56.8821L53.8681 18.9213L61.3563 18.9213L80.0791 18.9213L80.0791 45.1323L42.1184 83.0931L15.9074 56.8821Z",
    fill: "#EADDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0894 37.4496L26.3013 58.2376M44.8298 51.4589L32.1762 64.1125M47.5413 65.9202L40.7626 72.6989",
    stroke: "#EA5A5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5888 36.5458C68.3426 38.7921 64.7006 38.7921 62.4544 36.5458C60.2081 34.2995 60.2081 30.6576 62.4544 28.4113C64.7006 26.1651 68.3426 26.1651 70.5888 28.4113C72.7451 30.5676 72.8315 34.0099 70.848 36.2692C70.7652 36.3635 70.6788 36.4558 70.5888 36.5458Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95 21C95 30.3888 87.3888 38 78 38C71.4083 38 65.6929 34.2484 62.8724 28.7639C62.7507 28.5718 62.6326 28.3566 62.5187 28.1213",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesSale);
export default __webpack_public_path__ + "static/media/categoriesSale.ddf3a1d381e4a47b9bb6e7ee502a40e4.svg";
export { ForwardRef as ReactComponent };